import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ApiReview } from "src/api/types";
import FlatList from "src/components/FlatList";
import Review from "src/components/Review";
import useGet from "src/hooks/rest/useGet";

interface ResumeReviewsProps {
	query: string;
	variant: "default" | "registration";
	columns: number;
	options?: {
		scrollToTop?: boolean;
	};
}

const ResumeReviews = ({
	query,
	variant,
	columns,
	options,
}: ResumeReviewsProps) => {
	const { t } = useTranslation("resume", {
		keyPrefix: "resume-reviews",
	});
	const ref = useRef() as any;
	const [{ data }, loading, { pagination }] = useGet(
		query,
		{ data: [] },
		true
	);

	const setPage = (page: number) => {
		pagination.setPage(page);
		if (options?.scrollToTop && ref?.current) {
			const pos = ref?.current.getBoundingClientRect();
			const y = pos.top + window.pageYOffset - 140;
			window.scrollTo({ top: y, behavior: "smooth" });
		}
	};

	if (variant === "registration") {
		return (
			<div {...{ ref }} className="flex flex-col">
				<FlatList
					empty={{
						title: t("empty.title"),
					}}
					{...{ data, loading, columns }}
					pagination={{
						...pagination,
						setPage,
					}}
					renderItem={(item: ApiReview) => (
						<Review type="resume" key={item.id} review={item} />
					)}
				/>
			</div>
		);
	}

	return (
		<div {...{ ref }} className="flex flex-col">
			<FlatList
				empty={{
					title: t("empty.title"),
				}}
				{...{ data, loading, columns }}
				pagination={{
					...pagination,
					setPage,
				}}
				renderItem={(item: ApiReview) => (
					<Review type="resume" key={item.id} review={item} />
				)}
			/>
		</div>
	);
};

ResumeReviews.defaultProps = {
	variant: "default",
	columns: 1,
	options: {
		scrollToTop: true,
	},
};

export default ResumeReviews;
